import { render, staticRenderFns } from "./VlModalSelectDeadline.vue?vue&type=template&id=bd7ec58e&scoped=true&"
import script from "./VlModalSelectDeadline.vue?vue&type=script&lang=js&"
export * from "./VlModalSelectDeadline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7ec58e",
  null
  
)

export default component.exports